module.exports = __webpack_public_path__ + "static/img/42.ae26247.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/42.png
// module id = oIZX
// module chunks = 1